import { useMemo } from 'react';
import type { Product } from '@/api/products';
import { useDirectSaleStore } from '@/stores/directSaleStore';
import {
  effectiveMethodId,
  methodsForProduct,
  type DirectSaleMethod,
} from './direct-sale-methods';

/**
 * The decoration methods the customer can choose from for the product and
 * the one that applies: the pick while the decorated positions still
 * offer it, otherwise none (each position's default). One source for the
 * picker, the quote, the editor and the shown prices.
 */
export function useDirectSaleMethod(product: Product | null | undefined): {
  methods: DirectSaleMethod[];
  effectiveId: string | null;
} {
  const pickedId = useDirectSaleStore((s) => s.decorationMethodId);
  const decoratedPositions = useDirectSaleStore((s) => s.decoratedPositions);
  return useMemo(() => {
    const methods = methodsForProduct(
      product,
      decoratedPositions.map((position) => position.positionId)
    );
    return { methods, effectiveId: effectiveMethodId(methods, pickedId) };
  }, [product, decoratedPositions, pickedId]);
}
